import React from "react";
import HcsCaptionControl from "./hcs-captioncontrol";

export default class HcsTextArea extends HcsCaptionControl {
    constructor(props) {
        super(props);

        this.currentValue = "";
    }

    valueChanged(event) {
        // only trigger when value has changed
        if(event.target.value !== this.currentValue) {
            this.currentValue = event.target.value;
            this.props.onConfig("setCfgValue", event.target.getAttribute("attrName"), event.target.value, {
                sender: "HCS_TEXTAREA",
            });
        }
    }

    childClass() {
        return "hcs-textarea";
    }

    render() {
        const { data } = this.props;

        return super.render(
            <textarea
                attrname={data.ident}
                className={data.info.focused ? "hcs-focused" : null}
                readOnly={super.isEnabled() ? null : "readonly"}
                type="text"
                onBlur={(e) => this.valueChanged(e)}
            />
        );
    }
}
